import { TimelineFilter__ToUri } from "./Types.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { Activity_$reflection } from "../Shared/ApiDataTypes.js";
import { obj_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { orElse, bind, unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { mapFetchError } from "../Promises.js";
import { Activity_ActivityType__ColorCode, Activity_ActivityType, Activity_ActivityType_TryFromId_Z524259A4 } from "../Shared/Shared.js";
import { fromUtcToLocalDate, parseDateIso8601 } from "../Utils.js";
import { create, day, month, year } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { TimelineModule_timelineItem } from "../Fable.Vis.Timeline.js";
import { toString as toString_1 } from "../fable_modules/fable-library-js.4.24.0/Types.js";

export function fetchActivities(filter) {
    let properties_2;
    const url = "/api/activity/timeline" + TimelineFilter__ToUri(filter);
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Activity_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = undefined;
    try {
        const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Activity_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then(mapFetchError);
}

/**
 * Creates a timeline item from an activity
 */
export function createItem(groupId, maxDateDefault, activity) {
    const activityType = defaultArg(bind(Activity_ActivityType_TryFromId_Z524259A4, activity.ActivityType), new Activity_ActivityType(1, []));
    const singleDay = defaultArg(map((toDateStr) => {
        const fromDate = parseDateIso8601(activity.FromDate);
        const toDate = parseDateIso8601(toDateStr);
        if ((year(toDate) === year(fromDate)) && (month(toDate) === month(fromDate))) {
            return day(toDate) === day(fromDate);
        }
        else {
            return false;
        }
    }, activity.ToDate), false);
    let patternInput;
    const startDate = parseDateIso8601(activity.FromDate);
    patternInput = (singleDay ? [create(year(startDate), month(startDate), day(startDate), 0, 0, 0), create(year(startDate), month(startDate), day(startDate), 23, 59, 59)] : [startDate, orElse(map(parseDateIso8601, activity.ToDate), maxDateDefault)]);
    const toDateTooltip = defaultArg(map((x_1) => (` til ${fromUtcToLocalDate(x_1)}`), activity.ToDate), "(uten slutt)");
    const renderActivityTooltip = `
                <div><p>${isNullOrWhiteSpace(activity.InfoText) ? "Mangler beskrivelse" : activity.InfoText}</p>
                <p>Bekreftet: ${activity.Confirmed ? "Ja" : "Nei"}</p>
                <span>Fra ${fromUtcToLocalDate(activity.FromDate)}
                ${toDateTooltip}
                </span>
                </div>
            `;
    return TimelineModule_timelineItem([["id", activity.Id], ["start", patternInput[0]], ["end", patternInput[1]], ["group", groupId], ["content", `<span><span>${fromUtcToLocalDate(activity.FromDate)}${singleDay ? "" : defaultArg(map((x_2) => (" - " + fromUtcToLocalDate(x_2)), activity.ToDate), "")}</span>: ${toString_1(activityType)}</span>`], ["style", `background-color: ${Activity_ActivityType__ColorCode(activityType)}; border:none; height: ${30}px;`], ["title", renderActivityTooltip]]);
}

//# sourceMappingURL=API.js.map
